module.exports = {
      id: "c0f50d955a1d8c9eef00040559967797stairs.svg-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite.svg#c0f50d955a1d8c9eef00040559967797stairs.svg",
      toString: function () {
        return this.url;
      }
    }